// extracted by mini-css-extract-plugin
module.exports = {"position":"Header_position__y2w_C","mask":"Header_mask__joAFr"};